import { Popper, PopperProps } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import { getEmailAutocomplete } from "../../api/email/query_email";
import { useIsDesktop } from "../../hooks/use-is-desktop";
import { getDisplayName } from "../../utils/privacy";
import { useGlobalState } from "../globalState";

const CustomPopper = (props?: PopperProps) => {
	const desktop = useIsDesktop();

	return (
		<Popper
			{...props}
			style={{
				width: desktop ? "20vw" : "100vw",
			}}
			sx={{
				paddingTop: (theme) => theme.spacing(1),
			}}
		/>
	);
};

export const PersonSearch = () => {
	const { currentUser } = useGlobalState();
	const [searchOpen, setSearchOpen] = useState(false);
	const [searchLoading, setSearchLoading] = useState(false);
	const [searchOptions, setSearchOptions] = useState([]);
	const [searchQuery, setSearchQuery] = useState("");
	const desktop = useIsDesktop();

	useEffect(() => {
		if (searchQuery === "") {
			setSearchOptions([]);
			return undefined;
		}

		setSearchLoading(true);
		getEmailAutocomplete(searchQuery)
			.then(setSearchOptions)
			.then(() => {
				setSearchLoading(false);
			});
	}, [searchQuery]);

	return (
		<Autocomplete
			id="email_search"
			style={{ width: desktop ? "20vw" : "200px" }}
			open={searchOpen}
			size="small"
			slots={{ popper: CustomPopper }}
			onOpen={() => {
				setSearchOpen(true);
			}}
			onClose={() => {
				setSearchOpen(false);
			}}
			getOptionLabel={(option) =>
				`${getDisplayName(option.person_name, option.person_id, currentUser?.userprofile)} (${option.email})`
			}
			options={searchOptions}
			loading={searchLoading}
			onInputChange={(event, newInputValue) => {
				setSearchQuery(newInputValue);
			}}
			renderOption={(props, option) => {
				return (
					<Grid direction="column" container alignItems="center">
						<Grid>
							<Button
								href={`/person/${option.person_id}`}
								color="primary"
							>
								{getDisplayName(
									option.person_name,
									option.person_id,
									currentUser?.userprofile
								)}
							</Button>
						</Grid>
						<Grid>{option.email}</Grid>
					</Grid>
				);
			}}
			renderInput={(params) => (
				<TextField
					{...params}
					label="Search by email"
					variant="outlined"
					slotProps={{
						input: {
							...params.InputProps,
							sx: {
								background: (theme) => theme.palette.background.default,
							},
							endAdornment: (
								<React.Fragment>
									{searchLoading ? (
										<CircularProgress color="inherit" size={20} />
									) : null}
									{params.InputProps.endAdornment}
								</React.Fragment>
							),
						},
					}}
				/>
			)}
		/>
	);
};
